import React from "react";

const Title = ({ text }) => {
  return (
    <div className="relative bg- text-dark-blue-200 font-medium leading-7.5 text-16 before:content-viaq  before:absolute before:right-0 pr-9.5 ">
      {text}
    </div>
  );
};

export default Title;
